import * as React from 'react';
import Box from '@mui/material/Box';
import AppBar from '@mui/material/AppBar';
import ArticleIcon from '@mui/icons-material/Article';
import AddIcon from '@mui/icons-material/Add';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import { useQuery } from '../hooks/useQuery';
import { useAuth } from '../hooks/useAuth';
import CircularProgress from '@mui/material/CircularProgress';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import TextField from '@mui/material/TextField';
import RowNotaFiscal from '../components/RowNotaFiscal';
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import Moment from 'moment';
import { MobileDatePicker } from '@mui/x-date-pickers/MobileDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment';
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from 'react-router-dom';
import Pagination from '@mui/material/Pagination';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import IconButton from '@mui/material/IconButton';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import AlertaProtocoloVencido from '../components/AlertaProtocoloVencido';
import { useTheme } from '@mui/material/styles';
import { decryptData, encryptData, statuses, tryParse } from '../utils';
import 'moment/locale/pt-br';
import RowNotaFiscalDetails from '../components/RowNotaFiscalDetails';

export const NotasPage = (props) => {
  const navigate = useNavigate();
  const { listarNotas, detalheContrato, validarPermissaoEnvioNota } =
    useQuery();
  const { user, isUsuarioSebrae, isPrototocoloVencido } = useAuth();
  let { contratoId: contratoParams } = useParams();
  let dataParams = decryptData(contratoParams);
  dataParams = tryParse(dataParams);

  const [notas, setNotas] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [loadingContrato, setLoadingContrato] = React.useState(false);
  const [dataInicio, setDataInicio] = React.useState(
    Moment().subtract(1, 'year').set({ month: 5, date: 1 }).startOf('day'),
  );
  const [dataFim, setDataFim] = React.useState(Moment().endOf('year'));
  const [status, setStatus] = React.useState([]);
  const [numNota, setNumNota] = React.useState('');
  const [gestor, setGestor] = React.useState('');
  const datePickerRef = React.useRef();
  const [page, setPage] = React.useState(1);
  const [total, setTotal] = React.useState(0);
  const [lastPage, setLastPage] = React.useState(0);
  const theme = useTheme();
  const cnpj = dataParams.cnpj || '';
  const contratoId = dataParams.contrato || '';
  const isContract = dataParams.is_contract || '';
  const gestorTecnico = dataParams.gestor || '';
  const contratoDts = dataParams.contrato_dts || '';
  const [bloqueiaEnvio, setBloqueiaEnvio] = React.useState(false);
  const [runRequest, setRunRequest] = React.useState(false);

  React.useEffect(() => {
    if (!dataParams) {
      return navigate('/dashboard/contratos');
    }
  }, [dataParams]);

  React.useEffect(() => {
    if (datePickerRef) {
      datePickerRef.current.children[0].classList.remove('Mui-error');
      datePickerRef.current.children[1].classList.remove('Mui-error');
    }
  }, [datePickerRef]);

  const handleChange = (event, value) => {
    setPage(value);
    listar(contratoId, value);
  };

  const getFilters = () => {
    var filters = {};

    if (status.length > 0) {
      filters.status = status;
    }
    if (dataInicio !== '') {
      filters.data_inicio = dataInicio.format('YYYY-MM-DD');
    }
    if (dataFim !== '') {
      filters.data_fim = dataFim.format('YYYY-MM-DD');
    }
    if (numNota !== '') {
      filters.num_nota = numNota;
    }

    return filters;
  };

  const calendarioListar = async () => {
    const result = await validarPermissaoEnvioNota();
    if (result && result.data && result.data.data) {
      setBloqueiaEnvio(!result.data.data.permitido_envio_nota);
    }
  };

  const listar = async (contrato, pagina = 1) => {
    setLoading(true);
    let filters = getFilters();
    if (isContract) {
      filters.contrato = contrato;
    } else {
      filters.pedido = contrato;
    }

    console.log(filters);

    filters.paginate = true;
    filters.page = pagina;
    filters.is_contract = isContract;
    const result = await listarNotas(filters);

    if (result && result.data) {
      setNotas(
        result.data.data.data.map((item) => ({
          ...item,
          isLoading: false,
          showDetails: false,
        })),
      );
    }

    setPage(result.data.data.current_page);
    setLastPage(result.data.data.last_page);
    setTotal(result.data.data.total);
    setLoading(false);
  };

  const handleOnChangeFiltro = (event) => {
    const finalValue = event.target.value.toUpperCase();
    if (event.target.checked) {
      status.push(finalValue);
      setStatus([...status]);
    } else {
      const idx = status.indexOf(finalValue);
      status.splice(idx, 1);
      setStatus([...status]);
    }
  };

  const handleChangeInicio = (newValue) => {
    setDataInicio(newValue);
  };

  const handleChangeFim = (newValue) => {
    setDataFim(newValue);
  };

  const handleChangeNumNota = (event) => {
    setNumNota(event.target.value);
  };

  React.useEffect(() => {
    calendarioListar();
    if (user) {
      listar(contratoId);
    }

    setGestor(gestorTecnico);
    const interval = setInterval(() => {
      if (user) {
        listar(contratoId);
      }
    }, 300000);

    return () => clearInterval(interval);
  }, [runRequest]);

  return (
    <Box
      mt={8}
      sx={{ width: '100%', minHeight: '100vh' }}
      backgroundColor="#FAFCFF"
    >
      <AppBar position="static" color={'primary'} style={{ padding: 10 }}>
        <Grid container>
          <Grid
            item
            xs={12.5}
            alignItems="center"
            display="flex"
            justifyContent="space-between"
          >
            <Grid item display="flex" alignItems="center">
              <IconButton
                onClick={() =>
                  navigate(
                    cnpj
                      ? `/dashboard/contratos?cnpj=${cnpj}`
                      : '/dashboard/contratos',
                  )
                }
              >
                <ArrowBackIcon
                  sx={{
                    fontSize: 30,
                    display: { xs: 'none', md: 'flex' },
                    color: '#fff',
                  }}
                />
              </IconButton>

              <ArticleIcon
                sx={{
                  fontSize: 40,
                }}
              />
              <span style={{ color: 'white', fontSize: 20 }}>
                Notas Fiscais
              </span>
            </Grid>

            <span style={{ color: 'white', fontSize: 16 }}>
              {isContract ? `Contrato: ${contratoId}` : `Pedido: ${contratoId}`}
            </span>
          </Grid>
        </Grid>
      </AppBar>

      <AlertaProtocoloVencido cnpj={cnpj} />

      <Grid container spacing={1} paddingY="2rem" paddingX="1rem">
        <Grid item sm={12} display="flex" justifyContent="flex-end">
          <Grid
            item
            display="flex"
            flexDirection="column"
            alignItems="space-between"
            margin={0}
            padding={0}
          >
            {bloqueiaEnvio && (
              <span
                style={{
                  fontSize: '14px',
                  marginBottom: '4px',
                  display: 'block',
                }}
              >
                Data limite de emissão e envio encerrou. <br /> Consulte o
                calendário.
              </span>
            )}
            <Button
              disabled={
                (isUsuarioSebrae && isPrototocoloVencido) ||
                loadingContrato ||
                bloqueiaEnvio
              }
              onClick={() => {
                const dataEncrypted = encryptData(
                  JSON.stringify({
                    contrato: contratoId,
                    contrato_dts: contratoDts,
                    cnpj: cnpj,
                    is_contract: isContract,
                    gestor: gestorTecnico,
                  }),
                );

                navigate(`/dashboard/nota/${dataEncrypted}`);
              }}
              variant="contained"
              startIcon={<AddIcon />}
            >
              Enviar nova Nota Fiscal
            </Button>
          </Grid>
        </Grid>

        <Grid
          container
          padding={2}
          direction={{ xs: 'column-reverse', md: 'row', lg: 'row' }}
        >
          <Grid item sm={10} md="10" width="100%">
            {loading || loadingContrato ? (
              <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                <CircularProgress style={{ marginTop: 60 }} />
              </Box>
            ) : (
              <>
                <div
                  style={{
                    width: '100%',
                    overflowX: 'scroll',
                    overflowY: 'hidden',
                  }}
                >
                  <table className="app_table">
                    <thead
                      style={{
                        color: theme.palette.primary.main,
                        borderTop: `8px solid ${theme.palette.primary.light}`,
                      }}
                    >
                      <tr>
                        <th align="center">Nº da Nota</th>
                        <th align="center">Nº Processo</th>
                        <th align="center">Status</th>
                        <th align="center">Usuario</th>
                        <th align="center">Valor R$</th>
                        <th align="center">Data Envio</th>
                        <th align="center"></th>
                      </tr>
                    </thead>

                    <tbody>
                      {notas &&
                        notas.length > 0 &&
                        notas.map((nota, index) => (
                          <React.Fragment key={`nota${index}`}>
                            <RowNotaFiscal
                              index={index}
                              nota={nota}
                              cnpj={cnpj}
                              listar={listar}
                              contratoId={contratoId}
                              bloqueioEnvio={bloqueiaEnvio}
                              clickExpand={() => {
                                nota.showDetails = !nota.showDetails;
                                setNotas([...notas]);
                              }}
                              onClickEdit={() => {
                                const dataEncrypted = encryptData(
                                  JSON.stringify({
                                    contrato: contratoId,
                                    contrato_dts: contratoDts,
                                    cnpj: cnpj,
                                    is_contract: isContract,
                                    nota_id: nota.id,
                                    gestor: gestorTecnico,
                                  }),
                                );
                                navigate(`/dashboard/nota/${dataEncrypted}`);
                              }}
                              bloqueiaEnvio={bloqueiaEnvio}
                            />
                            {nota.showDetails && (
                              <RowNotaFiscalDetails
                                index={index}
                                nota={nota}
                                cnpj={cnpj}
                                expanded={nota.showDetails}
                              />
                            )}
                          </React.Fragment>
                        ))}

                      {!loading && notas && notas.length == 0 ? (
                        <tr>
                          <td colSpan={6} align="center">
                            Nenhuma nota fiscal encontrada.
                          </td>
                        </tr>
                      ) : null}
                    </tbody>
                  </table>
                </div>
                <Box
                  sx={{
                    display: 'flex',
                    justifyContent: 'center',
                  }}
                >
                  <Pagination
                    count={lastPage}
                    page={page}
                    color={'primary'}
                    onChange={handleChange}
                  />
                </Box>
              </>
            )}
          </Grid>
          <Grid item sm={2}>
            <Card
              variant="outlined"
              style={{
                borderTop: `8px solid ${theme.palette.primary.light}`,
              }}
            >
              <CardContent>
                <p
                  style={{
                    color: '#0e72b8',
                    marginTop: 0,
                    fontWeight: 'bold',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  <FilterAltIcon color="primary" />
                  Filtro
                </p>
                <p
                  style={{ color: '#0e72b8', marginTop: 0, fontWeight: 'bold' }}
                >
                  Status
                </p>
                <FormGroup>
                  {statuses.map((s, index) => {
                    return (
                      <FormControlLabel
                        key={index}
                        control={
                          <Checkbox
                            onChange={(e) => handleOnChangeFiltro(e, s)}
                            value={s.toUpperCase()}
                            checked={status.includes(s.toUpperCase())}
                          />
                        }
                        label={s}
                      />
                    );
                  })}
                </FormGroup>
                <p
                  style={{
                    color: '#0e72b8',
                    fontWeight: 'bold',
                    marginBottom: 0,
                  }}
                >
                  Nº da Nota
                </p>
                <TextField
                  style={{ width: '100%' }}
                  id="outlined-basic"
                  label="Número"
                  type="number"
                  value={numNota}
                  onInput={(e) => {
                    e.target.value = e.target.value
                      .substring(0, 16)
                      .replace(/[^0-9.]/g, '');
                  }}
                  inputProps={{
                    min: 0,
                    maxLength: 16,
                  }}
                  onChange={handleChangeNumNota}
                  variant="outlined"
                />
                <p
                  style={{
                    color: '#0e72b8',
                    fontWeight: 'bold',
                    marginBottom: '4px',
                  }}
                >
                  Data do envio
                </p>

                <LocalizationProvider
                  dateAdapter={AdapterMoment}
                  adapterLocale="ptBR"
                >
                  <Box>
                    <MobileDatePicker
                      ref={datePickerRef}
                      label="Data Início"
                      inputFormat="DD/MM/YYYY"
                      value={dataInicio}
                      onChange={handleChangeInicio}
                      renderInput={(params) => (
                        <TextField
                          error={false}
                          style={{ width: '100%' }}
                          {...params}
                        />
                      )}
                    />
                  </Box>
                  <Box sx={{ marginTop: 2 }}>
                    <MobileDatePicker
                      ref={datePickerRef}
                      label="Data Fim"
                      inputFormat="DD/MM/YYYY"
                      value={dataFim}
                      onChange={handleChangeFim}
                      renderInput={(params) => (
                        <TextField
                          error={false}
                          style={{ width: '100%' }}
                          {...params}
                        />
                      )}
                    />
                  </Box>
                </LocalizationProvider>
                <Button
                  variant="contained"
                  onClick={() => listar(contratoId)}
                  style={{ width: '100%', marginTop: 10 }}
                >
                  Buscar
                </Button>

                <Button
                  variant="contained"
                  color="error"
                  onClick={() => {
                    setDataInicio(
                      Moment()
                        .subtract(1, 'year')
                        .set({ month: 5, date: 1 })
                        .startOf('day'),
                    );
                    setDataFim(Moment().endOf('year'));
                    setStatus([]);
                    setNumNota('');
                    setRunRequest(!runRequest);
                  }}
                  style={{ width: '100%', marginTop: 20 }}
                >
                  Limpar
                </Button>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};
